// extracted by mini-css-extract-plugin
module.exports = {"divided":"nft-divided_divided__DfgUx"};